<template>
  <v-dialog v-model="dialogframeboton" persistent fullscreen>
    <v-card>
      <v-card-title :style="styleObject">
        <v-row>
          <v-col cols="11">
            <v-icon left>{{ iconodialogbtn }}</v-icon> {{ titledialogbtn }}
          </v-col>
          <v-col cols="1">
            <v-btn dark text color="blue" @click="dialogframeboton = false"
              >Cerrar</v-btn
            >
          </v-col>
          <v-col cols="12">
            <h6 v-if="infocolumna != null">
              {{ infocolumna.Columna[0].VC[1] }} ♦
              {{ infocolumna.Columna[0].VR[0] }} ♦
              {{ infocolumna.Columna[1].VR[2] }} ♦
              {{ infocolumna.Columna[1].VR[3] }} ♦
              {{ infocolumna.Columna[1].VR[4] }}
              <br />
              {{ infocolumna.Columna[1].VR[5] }} ♦
              {{ infocolumna.Columna[1].VR[10] }} ♦
              {{ infocolumna.Columna[1].VR[11] }}
            </h6>
            <h6 v-if="infoseguros != null">
              {{ infoseguros.Document_ID }} ♦ {{ infoseguros.NombreCompleto }} ♦
              {{ infoseguros.Direccion }} ♦
              {{ infoseguros.ComplementoDireccion }}
            </h6>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <!-- Cliente ¡-->
        <card-personas
          v-if="componenteview == 0"
          :infollaves="llaves"
          :pageiframe="dialogframeboton"
          :infopermisos="MPermisosTablero[0].ParametrosTablero"
        ></card-personas>
        <!-- Ubicación ¡-->
        <card-direcciones
          v-else-if="componenteview == 1"
          :typedocument="llaves.TypeDocument_ID"
          :document="llaves.Document_ID"
          :pageiframe="dialogframeboton"
          :infopermisos="MPermisosTablero[1].ParametrosTablero"
        ></card-direcciones>
        <!-- Nuevo Contacto ¡-->
        <card-newcontact
          v-else-if="componenteview == 2"
          :typedocument="llaves.TypeDocument_ID"
          :document="llaves.Document_ID"
          :pageiframe="dialogframeboton"
          :infopermisos="MPermisosTablero[2].ParametrosTablero"
        ></card-newcontact>
        <!-- Consulta Seguros ¡-->
        <card-seguros
          v-else-if="componenteview == 3"
          :infollaves="llaves"
          :pageiframe="dialogframeboton"
          :infopermisos="MPermisoSeguros"
          :paramiframeuno="param1"
        ></card-seguros>
        <!-- Consulta Documentos ¡-->
        <card-consultadocumentos
          v-else-if="componenteview == 4 || componenteview == 5"
          :infollaves="llaves"
        ></card-consultadocumentos>
      </v-card-text>
    </v-card>
  </v-dialog>
  <!-- Tablero de control Clientes -->
  <v-data-table
    v-model:page="pageTable"
    v-model:items-per-page="itemsPerPage"
    v-model:expanded="expanded"
    :headers="headers"
    :items="desserts"
    :search="search"
    item-value="index"
    show-expand
    height="550px"
  >
    <!-- PAGINADOR CUSTOM -->
    <template #bottom>
      <div
        class="d-flex align-center justify-space-between px-4 py-3 w-100 gap-4"
        style="border-top: 1px solid #e0e0e0"
      >
        <!-- Total de registros -->
        <div class="text-grey-darken-1 text-body-2">
          Total: <strong>{{ totalRecords }}</strong> registros
        </div>

        <!-- Paginador + Select en una sola línea -->
        <div class="d-flex align-center gap-4">
          <!-- Select tamaño página -->
          <v-select
            v-model="itemsPerPage"
            :items="[10, 20, 50, 100]"
            density="compact"
            variant="outlined"
            hide-details
            style="max-width: 110px"
            @update:modelValue="loadLazy"
            label="Registros"
          ></v-select>

          <!-- Paginador compacto -->
          <v-pagination
            v-model="page"
            :length="totalPages"
            total-visible="5"
            density="comfortable"
            rounded="circle"
            @update:modelValue="loadLazy"
          ></v-pagination>
        </div>
      </div>
    </template>

    <!-- FILTROS -->
    <template v-slot:top>
      <v-toolbar flat>
        <v-dialog v-model="dialogframe" persistent max-width="1000px">
          <template v-slot:activator="{ props }">
            <v-btn
              color="cyan"
              icon="mdi-filter-menu"
              size="x-large"
              dark
              class="mb-2"
              v-bind="props"
              @click="CargueCombo"
            >
            </v-btn>
          </template>
          <v-card>
            <v-toolbar dark color="red-darken-4">
              <v-toolbar-title
                ><v-icon left>mdi-filter-menu</v-icon> Filtros
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn dark text @click="reset">Limpiar</v-btn>
                <v-btn dark text @click="ValidateCampos">Consultar</v-btn>
                <v-btn dark text @click="dialogframe = false">Cerrar</v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <v-form ref="form" autocomplete="off">
                <v-row v-for="(datos, i) in modelfiltro" :key="i">
                  <!-- Filtro -->
                  <v-col cols="6">
                    <v-autocomplete
                      v-model="datos.filtro"
                      :items="items"
                      item-title="descripcion"
                      item-value="filtro"
                      label="Tipo de filtro:"
                      :clearable="datos.clear"
                      :readonly="datos.lectura"
                    ></v-autocomplete>
                  </v-col>
                  <!-- Contenido -->
                  <!--Tipo de seguro -->
                  <v-col v-if="i == 1" cols="12" sm="6" md="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArrayTipoSeguro"
                      :item-title="
                        (ArrayTipoSeguro) =>
                          ArrayTipoSeguro.Valor +
                          '-' +
                          ArrayTipoSeguro.Descripcion
                      "
                      item-value="Valor"
                      color="primary"
                      :label="datos.label"
                      dense
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                      clearable
                    >
                    </v-autocomplete>
                  </v-col>
                  <!--Estado -->
                  <v-col v-else-if="i == 3" cols="12" sm="6" md="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArrayEstado"
                      :item-title="
                        (ArrayEstado) =>
                          ArrayEstado.Valor + '-' + ArrayEstado.Descripcion
                      "
                      item-value="Valor"
                      color="primary"
                      :label="datos.label"
                      dense
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                    >
                    </v-autocomplete>
                  </v-col>
                  <!--Tipo de póliza -->
                  <v-col v-else-if="i == 4" cols="12" sm="6" md="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArrayTipoPoliza"
                      :item-title="
                        (ArrayTipoPoliza) =>
                          ArrayTipoPoliza.Valor +
                          '-' +
                          ArrayTipoPoliza.Descripcion
                      "
                      item-value="Valor"
                      color="primary"
                      :label="datos.label"
                      dense
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                    >
                    </v-autocomplete>
                  </v-col>
                  <!--Clase de Póliza -->
                  <v-col v-else-if="i == 5" cols="12" sm="6" md="6">
                    <v-autocomplete
                      v-model="datos.contenido"
                      :items="ArrayClasePoliza"
                      :item-title="
                        (ArrayClasePoliza) =>
                          ArrayClasePoliza.Valor +
                          '-' +
                          ArrayClasePoliza.Descripcion
                      "
                      item-value="Valor"
                      color="primary"
                      :label="datos.label"
                      dense
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col v-else cols="6">
                    <v-text-field
                      v-model="datos.contenido"
                      :label="datos.label"
                      :type="i == 6 || i == 7 ? 'date' : ''"
                      :clearable="datos.clear"
                      :readonly="datos.lectura"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-spacer></v-spacer>
        <!-- Buscador 
        <v-text-field
          v-model="search"
          append-inner-icon="mdi-magnify"
          label="Buscar..."
          single-line
          variant="underlined"
          hide-details
        ></v-text-field> -->
      </v-toolbar>
    </template>

    <!-- Registro Documento -->
    <template v-slot:item.Document_ID="{ item }">
      <!-- Registro Persona -->
      <div align="left">
        <!-- Seguros -->
        <v-tooltip location="bottom" color="white">
          <template v-slot:activator="{ props }">
            <v-icon @click="Iconos(item.raw, 3)" color="cyan" v-bind="props"
              >mdi-account-lock</v-icon
            >
          </template>
          <span>Seguros</span>
        </v-tooltip>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-tooltip location="bottom" color="white">
          <template v-slot:activator="{ props }">
            <span @click="Iconos(item.raw, 0)" v-bind="props">{{
              item.raw.Columna[0].VC[1]
            }}</span>
          </template>
          <span
            ><b> {{ item.raw.Columna[0].VR[0] }} </b><br />
            <v-icon
              size="x-large"
              :color="item.raw.Columna[0].VR[2]"
              v-bind="props"
              >{{ item.raw.Columna[0].VR[1] }}</v-icon
            >
            <v-icon
              size="x-large"
              :color="item.raw.Columna[0].VR[4]"
              v-bind="props"
              >{{ item.raw.Columna[0].VR[3] }}</v-icon
            >
            <v-icon
              size="x-large"
              :color="item.raw.Columna[0].VR[6]"
              v-bind="props"
              >{{ item.raw.Columna[0].VR[5] }}</v-icon
            >
            <v-icon
              size="x-large"
              :color="item.raw.Columna[0].VR[8]"
              v-bind="props"
              >{{ item.raw.Columna[0].VR[7] }}</v-icon
            >
            <v-icon
              size="x-large"
              :color="item.raw.Columna[0].VR[9]"
              v-bind="props"
              >{{ item.raw.Columna[0].VR[10] }}</v-icon
            >
          </span>
        </v-tooltip>
      </div>
    </template>

    <!-- Registro Ubicación -->
    <template v-slot:item.ubicacontact="{ item }">
      <div align="center">
        <!-- Registro Ubicación -->
        <v-tooltip location="bottom" color="white">
          <template v-slot:activator="{ props }">
            <v-icon
              @click="Iconos(item.raw, 1)"
              color="#0D9DA9"
              v-bind="props"
              >{{ item.raw.Columna[1].VC[0] }}</v-icon
            >
          </template>
          <span
            ><strong>
              {{ item.raw.Columna[0].VC[1] + " " }}
            </strong>
            <strong>{{ item.raw.Columna[0].VR[0] }} </strong> <br />
            <i> {{ item.raw.Columna[1].VR[2] }} </i> <br />
            <i> {{ item.raw.Columna[1].VR[3] }} </i> <br />
            <i> {{ item.raw.Columna[1].VR[4] }} </i> <br />
            <i> {{ item.raw.Columna[1].VR[5] }} </i> <br />
            <span
              v-if="
                item.raw.Columna[1].VR[6] != '' &&
                item.raw.Columna[1].VR[6] != null
              "
            >
              <i> {{ item.raw.Columna[1].VR[6] }} </i> <br />
            </span>
            <span
              v-if="
                item.raw.Columna[1].VR[7] != '' &&
                item.raw.Columna[1].VR[7] != null
              "
            >
              <i> {{ item.raw.Columna[1].VR[7] }} </i> <br
            /></span>
            <span
              v-if="
                item.raw.Columna[1].VR[8] != '' &&
                item.raw.Columna[1].VR[8] != null
              "
            >
              <i> {{ item.raw.Columna[1].VR[8] }} </i> <br />
            </span>
            <v-icon color="black">{{ item.raw.Columna[1].VR[1] }}</v-icon>
            <i> {{ item.raw.Columna[1].VR[9] }} </i> <br />
            <i>
              {{ item.raw.Columna[1].VR[10] + " - " }}
              {{ item.raw.Columna[1].VR[11] }}
            </i></span
          >
        </v-tooltip>
        <!-- Registro Nuevo Contacto -->
        <v-tooltip location="bottom" color="white">
          <template v-slot:activator="{ props }">
            <v-icon
              @click="Iconos(item.raw, 2)"
              color="orange"
              v-bind="props"
              >{{ item.raw.Columna[1].VR[0] }}</v-icon
            >
          </template>
          <span
            ><b> {{ item.raw.Columna[0].VR[0] }} </b><br />
            <v-icon
              size="x-large"
              :color="item.raw.Columna[0].VR[2]"
              v-bind="props"
              >{{ item.raw.Columna[0].VR[1] }}</v-icon
            >
            <v-icon
              size="x-large"
              :color="item.raw.Columna[0].VR[4]"
              v-bind="props"
              >{{ item.raw.Columna[0].VR[3] }}</v-icon
            >
            <v-icon
              size="x-large"
              :color="item.raw.Columna[0].VR[6]"
              v-bind="props"
              >{{ item.raw.Columna[0].VR[5] }}</v-icon
            >
            <v-icon
              size="x-large"
              :color="item.raw.Columna[0].VR[8]"
              v-bind="props"
              >{{ item.raw.Columna[0].VR[7] }}</v-icon
            >
            <v-icon
              size="x-large"
              :color="item.raw.Columna[0].VR[9]"
              v-bind="props"
              >{{ item.raw.Columna[0].VR[10] }}</v-icon
            >
          </span>
        </v-tooltip>
      </div>
    </template>

    <!-- Registro Archivo -->
    <template v-slot:item.archivo="{ item }">
      <div align="center">
        <!-- Registro Documentos Clientes -->
        <v-tooltip location="bottom" color="white">
          <template v-slot:activator="{ props }">
            <v-icon
              @click="Iconos(item.raw, 4)"
              size="x-large"
              color="deep-orange"
              v-bind="props"
              >{{ item.raw.Columna[2].VC[0] }}</v-icon
            >
          </template>
          <span>
            {{ item.raw.Columna[2].VR[0] }}
          </span>
        </v-tooltip>
      </div>
    </template>

    <!-- Registro Trazabilidad -->
    <template v-slot:item.trazabilidad="{ item }">
      <div align="center">
        <v-tooltip location="bottom" color="white">
          <template v-slot:activator="{ props }">
            <v-icon color="#2F6AE8" v-bind="props">{{
              item.raw.Columna[3].VC[0]
            }}</v-icon>
          </template>
          <span
            >{{ item.raw.Columna[3].VR[0] }}
            <br />
            <v-icon
              size="x-large"
              :color="item.raw.Columna[0].VR[2]"
              v-bind="props"
              >{{ item.raw.Columna[0].VR[1] }}</v-icon
            >
            <v-icon
              size="x-large"
              :color="item.raw.Columna[0].VR[4]"
              v-bind="props"
              >{{ item.raw.Columna[0].VR[3] }}</v-icon
            >
            <v-icon
              size="x-large"
              :color="item.raw.Columna[0].VR[6]"
              v-bind="props"
              >{{ item.raw.Columna[0].VR[5] }}</v-icon
            >
            <v-icon
              size="x-large"
              :color="item.raw.Columna[0].VR[8]"
              v-bind="props"
              >{{ item.raw.Columna[0].VR[7] }}</v-icon
            >
            <v-icon
              size="x-large"
              :color="item.raw.Columna[0].VR[9]"
              v-bind="props"
              >{{ item.raw.Columna[0].VR[10] }}</v-icon
            >
          </span>
        </v-tooltip>
      </div>
    </template>

    <!-- Expandir Campo -->
    <template v-slot:expanded-row="{ columns, item }">
      <!-- Tablero de Seguros -->
      <td :colspan="columns.length">
        <div align="center">
          <v-data-table
            v-model:page="itemsPerPage2"
            :headers="headerseguros"
            :items="item.raw.Columna[4].InfoSeguros"
          >
            <template v-slot:top>
              <v-toolbar color="red-darken-4" flat>
                <v-toolbar-title>
                  Seguros - {{ item.raw.Columna[0].VC[1] }} -
                  {{ item.raw.Columna[0].VR[0] }}</v-toolbar-title
                >
              </v-toolbar>
            </template>
            <template v-slot:item.GarantiaID="{ item }">
              <div align="left">
                <v-tooltip location="bottom" color="white">
                  <template v-slot:activator="{ props }">
                    <span v-bind="props">{{ item.raw.GarantiaID }} </span>
                  </template>
                  <span
                    >Estado: {{ item.raw.DescEstadoPoliza }} <br />
                    Tipo póliza: {{ item.raw.DescTipoPoliza }} <br />
                    Clase de póliza: {{ item.raw.DescClasePoliza }} <br />
                    Valor Prima: {{ item.raw.ValorPrima }} <br />
                    Valor Asegurado: {{ item.raw.ValorAsegurado }} <br />
                    Fecha Inicial: {{ item.raw.FechaInicial }} <br />
                    Fecha Final: {{ item.raw.FechaFinal }}
                  </span>
                </v-tooltip>
              </div>
            </template>
            <template v-slot:item.Estado="{ item }">
              <div align="center">
                <v-tooltip location="bottom" color="white">
                  <template v-slot:activator="{ props }">
                    <v-btn
                      v-bind="props"
                      :color="item.raw.ColorEstadoPoliza"
                      :icon="item.raw.IconoEstadoPoliza"
                      size="x-small"
                      @click="Iconos(null, 3, item.raw)"
                    ></v-btn>
                  </template>
                  <span> {{ item.raw.DescEstadoPoliza }} </span>
                </v-tooltip>
              </div>
            </template>
            <template v-slot:item.Document_ID_Aseguradora="{ item }">
              <div align="center">
                <v-tooltip location="bottom" color="white">
                  <template v-slot:activator="{ props }">
                    <span v-bind="props"
                      >{{ item.raw.Document_ID_Aseguradora }}
                    </span>
                  </template>
                  <span> {{ item.raw.NombreAseguradora }} </span>
                </v-tooltip>
              </div>
            </template>
            <!-- Registro Descripcion -->
            <template v-slot:item.descripcion="{ item }">
              <div align="center">
                <!-- Registro Documentos Clientes -->
                <v-tooltip location="bottom" color="white">
                  <template v-slot:activator="{ props }">
                    <v-icon color="blue" v-bind="props">mdi-information</v-icon>
                  </template>
                  <span> {{ item.raw.Descripcion }} </span>
                </v-tooltip>
              </div>
            </template>
            <!-- Registro Archivo -->
            <template v-slot:item.archivo="{ item }">
              <div align="center">
                <!-- Registro Documentos Clientes -->
                <v-tooltip location="bottom" color="white">
                  <template v-slot:activator="{ props }">
                    <v-icon
                      @click="Iconos(null, 5, item.raw)"
                      color="deep-orange"
                      v-bind="props"
                      >mdi-folder</v-icon
                    >
                  </template>
                  <span> Archivos de seguros </span>
                </v-tooltip>
              </div>
            </template>
            <!-- Registro Trazabilidad -->
            <template v-slot:item.trazabilidad="{ item }">
              <div align="center">
                <v-tooltip location="bottom" color="white">
                  <template v-slot:activator="{ props }">
                    <v-icon color="#2F6AE8" v-bind="props">mdi-magnify</v-icon>
                  </template>
                  <span> Trazabilidad Seguros </span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
        </div>
      </td>
    </template>
  </v-data-table>

  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Seguros from "@/views/TCI/ActivosO/Seguros/Seguros.vue";
import Personas from "@/views/TCI/Personas/Clientes/Clientes.vue";
import Direcciones from "@/views/TCI/Personas/Direcciones/Direcciones.vue";
import NuevoContacto from "@/views/TCI/Personas/NuevoContacto/NuevoContacto.vue";
import ConsultaDocumentos from "@/views/TCI/Documentos/ConsultaDocumentos/ConsultaDocumentos.vue";
export default {
  name: "control-activos",
  components: {
    "card-seguros": Seguros,
    "card-personas": Personas,
    "card-direcciones": Direcciones,
    "card-newcontact": NuevoContacto,
    "card-consultadocumentos": ConsultaDocumentos,
  },
  data() {
    return {
      //itemsPerPage: 1,
      itemsPerPage2: 1,
      pageTable: 1,
      itemsPerPage: 10,
      totalRecords: 0,
      totalPages: 0,
      expanded: [],
      singleExpand: false,
      styleObject: { border: "5px solid #B6332E" },
      search: "",
      progreso: false,
      dialogframe: false,
      dialogframeboton: false,
      estadoactual: false,
      iconodialogbtn: "",
      titledialogbtn: "",
      componenteview: 0,
      menubuttoms: [],
      infocolumna: [],
      infoseguros: [],
      llaves: {
        TypeDocument_ID: null,
        Document_ID: null,
        Primer_Apellido: null,
        Segundo_Apellido: null,
        Primer_Nombre: null,
        Segundo_Nombre: null,
        Solicitud: null,
        Contrato: null,
        Ref_1: null,
        Ref_2: null,
        Ref_3: null,
        IDServicio: null,
        IDPoliza: null,
        Secuencia_ID: null,
        Departamento: null,
        Ciudad: null,
      },
      items: [
        {
          filtro: "=",
          descripcion: "Igual a",
        },
        {
          filtro: "LIKE",
          descripcion: "Similar a",
        },
        {
          filtro: ">=",
          descripcion: "Mayor igual a",
        },
        {
          filtro: "<=",
          descripcion: "Menor igual a",
        },
      ],
      modelfiltro: [
        {
          campo: "Document_ID",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Documento:",
        },
        {
          campo: "TipoSeguro",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Tipo de Seguro:",
        },
        {
          campo: "Poliza",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Póliza:",
        },
        {
          campo: "EstadoPoliza",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Estado de póliza:",
        },
        {
          campo: "TipoPoliza",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Tipo de póliza:",
        },
        {
          campo: "ClasePoliza",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Clase de póliza:",
        },
        {
          campo: "FechaInicial",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Fecha Inicial:",
        },
        {
          campo: "FechaFinal",
          filtro: null,
          contenido: null,
          lectura: false,
          clear: true,
          label: "Fecha Final:",
        },
      ],
      headers: [
        {
          title: "Documento",
          align: "left",
          key: "Document_ID",
        },
        {
          title: "Ubicación/Contacto",
          align: "center",
          sortable: false,
          key: "ubicacontact",
        },
        {
          title: "Archivos",
          align: "center",
          sortable: false,
          key: "archivo",
        },
        {
          title: "Trazabilidad",
          align: "center",
          sortable: false,
          key: "trazabilidad",
        },
        { title: "", key: "data-table-expand" },
      ],
      headerseguros: [
        {
          title: "Garantia",
          align: "left",
          key: "GarantiaID",
        },
        {
          title: "Estado",
          align: "center",
          sortable: false,
          key: "Estado",
        },
        {
          title: "Póliza",
          align: "left",
          key: "Poliza",
        },
        {
          title: "Fecha Vencimiento",
          align: "left",
          key: "FechaFinal",
        },
        {
          title: "Aseguradora",
          align: "center",
          sortable: false,
          key: "Document_ID_Aseguradora",
        },
        {
          title: "Descripción",
          align: "center",
          sortable: false,
          key: "descripcion",
        },
        {
          title: "Archivos",
          align: "center",
          sortable: false,
          key: "archivo",
        },
        {
          title: "Trazabilidad",
          align: "center",
          sortable: false,
          key: "trazabilidad",
        },
      ],
      desserts: [],
      MPermisosTablero: [],
      MPermisoSeguros: null,
      ArrayTipoSeguro: [],
      ArrayEstado: [],
      ArrayTipoPoliza: [],
      ArrayClasePoliza: [],
      param1: "",
      param2: "",
      busquedacompleta: false,
    };
  },
  methods: {
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Validación de campos
    async ValidateCampos() {
      var validate = false;
      this.busquedacompleta = false;
      for (var i = 0; i < this.modelfiltro.length; i++) {
        if (
          (this.modelfiltro[i].filtro == "" ||
            this.modelfiltro[i].filtro == null) &&
          this.modelfiltro[i].contenido != "" &&
          this.modelfiltro[i].contenido != null
        ) {
          validate = true;
        } else if (
          (this.modelfiltro[i].contenido == "" ||
            this.modelfiltro[i].contenido == null) &&
          this.modelfiltro[i].filtro != "" &&
          this.modelfiltro[i].filtro != null
        ) {
          validate = true;
        } else if (
          (this.modelfiltro[i].contenido != "" ||
            this.modelfiltro[i].contenido != null) &&
          this.modelfiltro[i].filtro != "" &&
          this.modelfiltro[i].filtro != null
        ) {
          this.busquedacompleta = true;
        }
      }

      this.getPermisosTablero();
      this.getConsultaTablero(1, 10);
      // Consultas a Ejecutar
      //if (!validate) {
      //} else {
      //this.$swal({
      //icon: "warning",
      //title: "Campos Incompletos.",
      //html: " Hay campos que se encuentran incompletos o no contiene el respecitivo filtro.",
      //});
      //}
    },

    async loadLazy() {
      await this.getConsultaTablero();
    },

    // Consulta Tablero
    async getConsultaTablero(pages, itempages) {
      this.desserts = [];
      this.expanded = [];
      this.progreso = true;

      if (pages && itempages) {
        this.itemsPerPage = 10;
        this.page = 1;
      }

      var data = {
        filtrado: this.modelfiltro,
        busquedacompleta: this.busquedacompleta,
        tamaniopagina: this.itemsPerPage,
        numeropagina: this.page,
      };
      this.axios
        .post("/ControlGarantias/GetCT0/", data)
        .then((result) => {
          //this.itemsPerPage = 1;
          this.itemsPerPage2 = 1;
          this.desserts = result.data;
          if (this.desserts.length == 1) {
            this.expanded.push(0);
          }
          this.totalRecords = result.data[0].CountRegister;
          this.totalPages = Math.ceil(this.totalRecords / this.itemsPerPage);
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
          this.dialogframe = false;
        });
    },
    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    //Trabajar iconos
    Iconos(infodata, iconoelegido, infoseguro) {
      this.dialogframeboton = true;
      this.componenteview = iconoelegido;
      this.llaves.Solicitud = null;
      this.llaves.Contrato = null;
      this.llaves.Ref_1 = null;
      this.llaves.Ref_2 = null;
      this.llaves.Ref_3 = null;
      this.llaves.Departamento = null;
      this.llaves.Ciudad = null;
      this.llaves.IDPoliza = null;
      this.llaves.Secuencia_ID = null;
      if (infoseguro != undefined && infoseguro != null) {
        this.llaves.IDPoliza = infoseguro.Seguro_ID.toString();
        this.llaves.TypeDocument_ID = infoseguro.TypeDocument_ID.toString();
        this.llaves.Document_ID = infoseguro.Document_ID;
        this.llaves.Primer_Nombre = infoseguro.NombreCompleto;
        this.infoseguros = infoseguro;
        this.infocolumna = null;
        this.MPermisoSeguros = this.MPermisosTablero[3].ParametrosTablero;
      } else {
        this.llaves.TypeDocument_ID = infodata.Columna[0].VC[2].toString();
        this.llaves.Document_ID = infodata.Columna[0].VC[1];
        this.llaves.Primer_Nombre = infodata.Columna[0].VR[0];
        this.infoseguros = null;
        this.infocolumna = infodata;
        this.MPermisoSeguros = "0110";
      }
      switch (iconoelegido) {
        case 0: //Cliente
          this.iconodialogbtn = "mdi-account";
          this.titledialogbtn = "Clientes";
          break;
        case 1: //Ubicación
          this.iconodialogbtn = "mdi-map-marker-plus";
          this.titledialogbtn = "Ubicación";
          break;
        case 2: //Nuevo Contacto
          this.iconodialogbtn = "mdi-account-multiple-plus";
          this.titledialogbtn = "Nuevo Contacto";
          break;
        case 3: //Seguros
          this.iconodialogbtn = "mdi-file-lock";
          this.titledialogbtn = "Seguros";
          break;
        case 4: //Documentos CLientes
          this.iconodialogbtn = "mdi-file-search";
          this.titledialogbtn = "Documentos CLientes";
          break;
        case 5: //Documentos Seguros
          this.iconodialogbtn = "mdi-file-search";
          this.titledialogbtn = "Documentos Contratos";
          break;
      }
    },
    // Limpiar campos
    reset() {
      this.busquedacompleta = false;
      this.$refs.form.reset();
      if (this.param2 != null && this.param2 != "") {
        this.modelfiltro[8].filtro = "=";
        this.modelfiltro[8].contenido = this.param2;
        this.modelfiltro[8].clear = false;
        this.modelfiltro[8].lectura = true;
      }
    },
    // Cargar combos de filtros
    CargueCombo() {
      var arrayTabla = this.$store.getters.MTablaSeleccion;
      this.ArrayTipoSeguro = arrayTabla.filter(
        (item) => item.Valor != null && item.TablaId == 24
      );

      this.ArrayEstado = arrayTabla.filter(
        (item) => item.Valor != null && item.TablaId == 25
      );

      this.ArrayTipoPoliza = arrayTabla.filter(
        (item) => item.Valor != null && item.TablaId == 26
      );

      this.ArrayClasePoliza = arrayTabla.filter(
        (item) => item.Valor != null && item.TablaId == 27
      );
    },
    
    //Permisos de Tablero
    async getPermisosTablero() {
      var userperfil = this.$store.getters.userperfil.infoperfil;
      var page = this.$store.getters.userperfil.paginainfo;

      this.axios
        .get(
          "/parametros/CD5?Perfil=" +
            userperfil.Perfil_ID +
            "&Pagina=" +
            page.id_link
        )
        .then((response) => {
          this.MPermisosTablero = response.data;

          // Servicios
          var ArrayServices = this.MPermisosTablero.filter(
            (item) => item.Descripcion == "Servicios Historico"
          );
          this.PermisoHistorico = ArrayServices[0].ParametrosTablero;

          var ArrayServices = this.MPermisosTablero.filter(
            (item) => item.Descripcion == "Botón Documentos"
          );
          this.MPermisosFolderDocumentos =
            ArrayServices[0].ParametrosTablero.split("");
          console.log(this.MPermisosFolderDocumentos);
        })
        .catch((e) => console.log(e));
    },

    // Busca los parametros de la pagina
    parametrospaginas() {
      var page = this.$store.getters.userperfil.paginainfo;
      if (page.param1) {
        this.param1 = page.param1;
      }
      if (page.param2 != null && page.param2 != "") {
        this.param2 = parseInt(page.param2);
        this.modelfiltro[8].filtro = "=";
        this.modelfiltro[8].contenido = this.param2;
        this.modelfiltro[8].clear = false;
        this.modelfiltro[8].lectura = true;
      }
    },
  },
  mounted() {
    this.parametrospaginas();
  },
};
</script>
